import { render, staticRenderFns } from "./PreventiveInternalList.vue?vue&type=template&id=25fce6f6"
import script from "./PreventiveInternalList.vue?vue&type=script&lang=js"
export * from "./PreventiveInternalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports